module.exports = require('../../modules/vars');
